import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import {
  PRODUCT_FINDER_CONVERTER_TOKEN,
  ProductFinderConverter
} from './components/product-finder/product-finder.component.converter'
import {
  PRODUCT_FINDER_STEP_CONVERTER_TOKEN,
  ProductFinderStepConverter
} from './components/product-finder-step/product-finder-step.component.converter'
import {
  PRODUCT_FINDER_ANSWER_TILE_CONVERTER_TOKEN, ProductFinderAnswerTileConverter
} from './components/product-finder-answer-tile/product-finder-answer-tile.component.converter'
import {
  PRODUCT_FINDER_ANSWER_TILE_WITH_OPTIONS_CONVERTER_TOKEN, ProductFinderAnswerTileWithOptionsConverter
} from './components/product-finder-answer-tile-with-options/product-finder-answer-tile-with-options.component.converter'
import {
  PRODUCT_FINDER_ANSWER_TILE_OPTION_CONVERTER_TOKEN,
  ProductFinderAnswerTileOptionConverter
} from './components/product-finder-answer-tile-option/product-finder-answer-tile-option.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        productFinderFeature: {
          module: () => import('./product-finder.module').then((m) => m.ProductFinderModule),
          cmsComponents: ['product_finder']
        },
      }
    }),
    {
      provide: PRODUCT_FINDER_CONVERTER_TOKEN,
      useExisting: ProductFinderConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        product_finder: PRODUCT_FINDER_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PRODUCT_FINDER_STEP_CONVERTER_TOKEN,
      useClass: ProductFinderStepConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        product_finder_step: PRODUCT_FINDER_STEP_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PRODUCT_FINDER_ANSWER_TILE_CONVERTER_TOKEN,
      useClass: ProductFinderAnswerTileConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        product_finder_answer_tile: PRODUCT_FINDER_ANSWER_TILE_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PRODUCT_FINDER_ANSWER_TILE_WITH_OPTIONS_CONVERTER_TOKEN,
      useClass: ProductFinderAnswerTileWithOptionsConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        product_finder_answer_tile_with_options: PRODUCT_FINDER_ANSWER_TILE_WITH_OPTIONS_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PRODUCT_FINDER_ANSWER_TILE_OPTION_CONVERTER_TOKEN,
      useClass: ProductFinderAnswerTileOptionConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        product_finder_tile_option: PRODUCT_FINDER_ANSWER_TILE_OPTION_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class ProductFinderFeatureModule {}
